export const ESTIMATED_ITEM_SIZE = 45;
